<div class="sub-menu" [ngClass]="{ collapsed: isCollapsed, active: isActive }">
  <div class="label" (click)="isCollapsed = !isCollapsed">
    {{ name }}
    <craft-icon class="svg-icon arrow-icon" name="arrows--arrow-right-b-sm"></craft-icon>
  </div>
  <div class="sub-list" *ngIf="!isCollapsed">
    <ng-content />
  </div>
</div>
